import { AllocationData, AllocationDataItem } from "./types";

export const selectAllocation = (data: AllocationData, startYear: number, targetYear: number): AllocationDataItem | null => {
  const allocation = data.reduce((result: AllocationDataItem | null, item: AllocationDataItem) => {
    if (item.minYear <= targetYear - startYear && (!result || result?.minYear < item.minYear)) return item
    return result
  }, null)
  return allocation
}